export class RememberMeModel{
    isActive:boolean|undefined;
    userName:string|undefined;
    token:string|undefined;
}